import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface HeadquarterProfileState {
    selectedView: string;
}

const initialState: HeadquarterProfileState = {
    selectedView: 'info',
};

const headquarterProfileSlice = createSlice({
    name: 'headquarterProfile',
    initialState,
    reducers: {
        setSelectedView(state, action: PayloadAction<string>) {
            state.selectedView = action.payload;
        },
    },
});

export const { setSelectedView } = headquarterProfileSlice.actions;
export default headquarterProfileSlice.reducer;
